<nz-layout class="top-layout">
  <nz-header class="width-100">
    <div nz-row class="top-header">
      <div nz-col nzFlex="256px" routerLink="/" class="logo">
        <ng-container *ngIf="WorkersData.XencioIcon === 'show'">
          <img
            [src]="'assets/img/logo-color' + (WorkersData.openBy === 'Xencio' ? '' : '-' + WorkersData.openBy) + '.png'"
            (click)="goHome()"
            alt="logo"
          />
        </ng-container>

        <a *ngIf="mainUrl" class="ml-md text-primary" [href]="mainUrl">返回主页</a>
      </div>
      <div nz-col nzFlex="auto"><router-outlet name="top"></router-outlet></div>
    </div>
  </nz-header>
  <nz-content>
    <div class="top-title">
      <div class="sub"><router-outlet name="titleMiddle"></router-outlet></div>
    </div>
    <div class="top-content"><router-outlet></router-outlet></div>
  </nz-content>
</nz-layout>
